import React from "react";
import Picture from "../components/Navbar Components/Picture";
import FarmerLoginForm from "./FarmerLoginForm";

const FarmerLogin = () => {
  return (
    <>
      <Picture />
      <FarmerLoginForm />
    </>
  );
};
export default FarmerLogin;